let isCustomEvent = false;

async function onCheckoutClick(event, btn) {
  if (isCustomEvent) {
    isCustomEvent = false;
    return true;
  }
  isCustomEvent = true;
  event.stopImmediatePropagation();
  event.preventDefault();

  validationTextForCart();

  const inputThreekitImage = document.querySelector(
    'input[name="properties[Threekit [Threekit Image]]"]'
  );
  const threekitImageSrc = await createThreekitImg();
  if (inputThreekitImage) {
    inputThreekitImage.value = threekitImageSrc;
  }

  btn.click();

  setTimeout(() => {
    const shoppingCartItems = Array.from(
      document.getElementsByClassName("#cart-item")
    );

    shoppingCartItems.forEach((cartItem) => {
      const listOfCartItemProps =
        cartItem.getElementsByClassName("#cart-item-props");

      const cartItemPropsHtml = listOfCartItemProps[0]?.children;
      if (cartItemPropsHtml !== undefined) {
        const cartItemProps = Array.from(cartItemPropsHtml);
        const threekitImageField = cartItemProps.find((el) =>
          el.textContent.includes("Threekit")
        );

        if (threekitImageField) {
          const data = threekitImageField.innerHTML.split("base64")[1];

          if (data !== undefined) {
            let newImage = new Image();
            newImage.classList.add("cart_threekit_img");
            const src = `data:image/png;base64,${data}`;
            newImage.src = src;

            const cartImage =
              cartItem.getElementsByClassName("#cart-item-image");
            const shopifyImg = cartImage[0].childNodes[1];
            cartImage[0].removeChild(shopifyImg);
            cartImage[0].appendChild(newImage);
          }
          listOfCartItemProps[0].removeChild(threekitImageField);
        }
      }
    });
  }, 3000);
}

function validationTextForCart() {
  const targetNode = document.getElementsByClassName("#modal-popup-content");
  const config = { childList: true };
  const callback = (mutationList, observer) => {
    let threekitField;
    const config = /[{",};]/g;
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        const modalCart = Array.from(
          document.getElementsByClassName("#cart-item-props")
        );

        modalCart.forEach((cart) => {
          const optiionsInfo = Array.from(cart.childNodes);
          optiionsInfo.map((info) => {
            if (info.innerHTML) {
              const text = info.innerHTML.replace("=&gt", "{");
              const newText = text.split("{");
              newText.splice(1, 1);
              info.innerHTML = newText.join().replace(config, "");
            }
          });
        });
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode[0], config);
}

async function clickOnShoppingCartIcon() {
  console.log("clickOnShoppingCartIcon");
  validationTextForCart();

  const inputThreekitImage = document.querySelector(
    'input[name="properties[Threekit [Threekit Image]]"]'
  );
  const threekitImageSrc = await createThreekitImg();
  if (inputThreekitImage) {
    inputThreekitImage.value = threekitImageSrc;
  }

  setTimeout(() => {
    const shoppingCartItems = Array.from(
      document.getElementsByClassName("#cart-item")
    );

    shoppingCartItems.forEach((cartItem) => {
      const listOfCartItemProps =
        cartItem.getElementsByClassName("#cart-item-props");

      const cartItemPropsHtml = listOfCartItemProps[0]?.children;

      if (cartItemPropsHtml !== undefined) {
        const cartItemProps = Array.from(cartItemPropsHtml);
        const threekitImageField = cartItemProps.find((el) =>
          el.textContent.includes("Threekit")
        );

        if (threekitImageField) {
          threekitImageField.classList.add("threekit-img-hide");
          const data = threekitImageField.innerHTML.split("base64")[1];

          if (data !== undefined) {
            let newImage = new Image();
            newImage.classList.add("cart_threekit_img");
            const src = `data:image/png;base64,${data}`;
            newImage.src = src;

            const cartImage =
              cartItem.getElementsByClassName("#cart-item-image");

            const shopifyImg = cartImage[0].childNodes[1];
            cartImage[0].removeChild(shopifyImg);
            cartImage[0].appendChild(newImage);
          }
          listOfCartItemProps[0].removeChild(threekitImageField);
        }
      }
    });
  }, 0);
  if (window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function'){
    setTimeout(function(){
          BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
    },200);
  }
}
